<template>
  <div ref="dropdown" :class="buttonWarpperClass">
    <!-- Dropdown Toggle Button -->
    <button :class="buttonClass" @click="toggleDropdown" :disabled="disabled">
      <span :class="buttonTextClass">{{ selectedLabel }}</span>

      <div :class="buttonIconClass">
        <img src="../../assets/images/create-quote-icon.png" />
      </div>

      <div :class="buttonDropdownIcon">
        <i class="fa fa-angle-down !text-[24px]"></i>
      </div>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" :class="dropdownListClass">
      <!-- Local Search -->
      <div :class="dropdownSearchWrapperClass">
        <input ref="searchInput" v-model="searchQuery" type="text" :placeholder="searchPlaceholder"
          :class="dropdownSearchInputClass" @click.stop />
      </div>

      <ul class="list-inline mb-0 p-0 max-h-60 overflow-y-auto">
        <li v-for="(item, index) in filteredItems" :key="index" :class="dropdownListLIClass">
          <a :class="dropdownListAnchorClass" @click="selectItem(item)">
            {{ item[labelKey] }}
          </a>
        </li>

        <li v-if="filteredItems.length <= 0" :class="noResultClass">
          {{ noResultText }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";

export default {
  emits: ["update:modelValue", "select"],
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    buttonWarpperClass: [String, Array, Object],
    buttonClass: [String, Array, Object],
    buttonIconClass: [String, Array, Object],
    buttonDropdownIcon: [String, Array, Object],
    buttonTextClass: [String, Array, Object],
    buttonText: String,
    dropdownListClass: [String, Array, Object],
    dropdownListLIClass: [String, Array, Object],
    dropdownListAnchorClass: [String, Array, Object],
    dropdownSearchWrapperClass: [String, Array, Object],
    dropdownSearchInputClass: [String, Array, Object],
    noResultClass: [String, Array, Object],
    searchPlaceholder: {
      type: String,
      default: "Search...",
    },
    noResultText: {
      type: String,
      default: "No result found",
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      searchQuery: "",
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.items.find((item) => {
        if (this.valueKey === "object") {
          return JSON.stringify(item) === JSON.stringify(this.modelValue);
        }
        return item[this.valueKey] === this.modelValue;
      });
      return selected ? selected[this.labelKey] : this.buttonText;
    },

    filteredItems() {
      const query = this.searchQuery.trim().toLowerCase();
      if (query.length <= 0) return this.items;

      return this.items.filter((item) =>
        String(item[this.labelKey] ?? "").toLowerCase().includes(query)
      );
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      this.searchQuery = "";

      if (this.isOpen) {
        nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      }
    },
    selectItem(item) {
      const value = this.valueKey === "object" ? item : item[this.valueKey];
      this.$emit("update:modelValue", value);
      this.$emit("select", item);
      this.isOpen = false;
      this.searchQuery = "";
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
        this.searchQuery = "";
      }
    },
  },
};
</script>
